import React from "react"
import PageLinks from "../constants/links"
import { FaTimes } from "react-icons/fa"
import "../css/sidebar.css"

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <aside className={`sidebar ${isOpen ? "show-sidebar" : ""} `}>
      <button className="close-btn noSelect" onClick={toggleSidebar}>
        <FaTimes />
      </button>
      <div className="side-container noSelect">
        <PageLinks styleClass={`${isOpen ? "sidebar-links" : ""}`} />
      </div>
    </aside>
  )
}

export default Sidebar
